<script setup lang="ts">
import { useAppSettingsStore } from '@convatec/180medical-website/app/stores/app-settings'

const { showFooterForm } = useLayoutFlags()
const appSettingsStore = useAppSettingsStore()
if (!appSettingsStore.headerNav.length) {
  await appSettingsStore.fetchNavigation()
}

onMounted(() => {
  appSettingsStore.init()
})
</script>

<template>
  <a
    href="#main"
    class="absolute top-0 left-0 w-px h-px overflow-hidden whitespace-nowrap text-white bg-med-deep-navy focus:w-auto focus:h-auto focus:z-[1000] focus:px-5 focus:py-2.5"
  >
    Skip to main content
  </a>
  <AlertsContainer />
  <LazyLayoutHeader :header-logo="appSettingsStore.headerLogo">
    <template #upper>
      <LazyLayoutUpperHeader
        :login-menu-settings="appSettingsStore.loginMenuSettings"
        :header-settings="appSettingsStore.headerSettings"
      />
    </template>
    <template #mobileNav>
      <LazyBlockNavigationMobile
        :items="appSettingsStore.headerNav"
        :login-menu-settings="appSettingsStore.loginMenuSettings"
        :header-settings="appSettingsStore.headerSettings"
      />
    </template>
    <template #mainNav>
      <LazyBlockNavigationDesktop :items="appSettingsStore.headerNav" />
    </template>
    <template #actions />
  </LazyLayoutHeader>
  <LazyUiContainer
    id="main"
    as="main"
    class="w-full pt-10 xl:pt-17.5"
    full-width
    no-padding
  >
    <slot />
  </LazyUiContainer>
  <!-- <LazyLayoutPreFooter /> -->
  <!-- ClientOnly: pages set showFooterForm after the layout's v-if is evaluated, so SSR
       renders a comment but hydrates a section. The form is HubSpot-injected on mount. -->
  <ClientOnly>
    <LazyLayoutFormFooter
      v-if="showFooterForm.valueOf()"
      title="Contact Us"
    >
      <div id="hs-contact-form-container" />
    </LazyLayoutFormFooter>
  </ClientOnly>
  <footer>
    <LazyLayoutFooter :footer-settings="appSettingsStore.footerSettings" />
    <LazyLayoutPostFooter
      v-if="appSettingsStore.footerSettings.interestLinks"
      :interest-links="appSettingsStore.footerSettings.interestLinks"
    />
  </footer>
</template>
